import { useState } from 'react';
import CaresExceptionModal from './CaresExceptionModal';
import CaresSection from './sections/CaresSection';
import { CARES_TYPE_VALUES, FUND_TYPES } from '../../../../constants/constants';

const CaresContainer = ({ form, formData, setFormField, onCaresTypeChange, isSubmitting }) => {
  const [showExceptionModal, setShowExceptionModal] = useState(false);

  const handleExceptionModalYes = () => {
    setFormField('caresType', CARES_TYPE_VALUES.EXCEPTIONREQUEST);
    setFormField('caresExceptionRequestFlg', true);
    setShowExceptionModal(false);
  };

  const handleExceptionModalNo = () => {
    setFormField('caresType', '');
    setShowExceptionModal(false);
  };

  return (
    <>
      <CaresSection
        form={form}
        formData={formData}
        setFormField={setFormField}
        onShowExceptionModal={() => setShowExceptionModal(true)}
        onCaresTypeChange={onCaresTypeChange}
        isSubmitting={isSubmitting}
      />

      {/* CARES-owned modals */}

      <CaresExceptionModal
        show={showExceptionModal}
        onYes={handleExceptionModalYes}
        onNo={handleExceptionModalNo}
        pledgesApplied={formData?.pledgesAppliedWithCurrentProgramYear?.[FUND_TYPES.CARES]}
        totalApplied={formData?.totalCaresGrantsApplied}
      />
    </>
  );
};

export default CaresContainer;